export default {
  "site.name": "1996至成国际",
  "site.slogan": "专业国际化服务平台",
  "site.description": "1996至成国际app官方下载 - 安全稳定的一站式国际化服务体验",
  "nav.home": "首页",
  "nav.categories": "服务分类",
  "nav.articles": "资讯中心",
  "nav.about": "关于我们",
  "nav.download": "下载APP",
  "footer.copyright": "© 2026 1996至成国际 版权所有",
  "footer.icp": "ICP备案号：粤ICP备xxxxxxxx号",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "breadcrumb.home": "首页",
  "breadcrumb.categories": "服务分类",
  "breadcrumb.articles": "资讯中心",
  "breadcrumb.about": "关于我们",
  "cta.download_now": "立即下载",
  "cta.learn_more": "了解更多",
  "cta.view_all": "查看全部",
  "cta.contact_us": "联系我们",
  "home.hero.title": "1996至成国际",
  "home.hero.subtitle": "专业国际服务平台 · 安全稳定 · 极速体验",
  "home.hero.description": "至成国际app为您提供安全稳定的一站式国际化服务体验，便捷操作、极速响应，覆盖全球服务支持，注册即享专属福利。",
  "home.features.title": "为什么选择1996至成国际",
  "home.features.subtitle": "四大核心优势，为您保驾护航",
  "home.download.title": "立即下载1996至成国际官方APP",
  "home.download.subtitle": "支持iOS与Android双平台，安全正版，极速体验",
  "home.categories.title": "服务分类",
  "home.categories.subtitle": "多元化服务，满足您的各类需求",
  "home.articles.title": "最新资讯",
  "home.articles.subtitle": "掌握行业动态，了解最新政策",
  "home.stats.users": "全球用户",
  "home.stats.countries": "覆盖国家",
  "home.stats.services": "服务项目",
  "home.stats.years": "年行业经验",
  "about.title": "关于1996至成国际",
  "about.brand.title": "品牌介绍",
  "about.brand.description": "1996至成国际成立于1996年，是一家专注于国际化服务的综合性平台。我们致力于为全球用户提供安全、稳定、高效的一站式服务体验，涵盖跨境商务、国际投资、文化交流等多个领域。",
  "about.reputation.title": "品牌信誉",
  "about.reputation.description": "多年来，至成国际凭借卓越的服务品质和专业的团队，赢得了全球数百万用户的信赖。我们始终坚持安全第一、用户至上的原则，为用户提供可靠的国际化服务保障。",
  "about.contact.title": "联系我们",
  "about.contact.address": "公司地址",
  "about.contact.phone": "联系电话",
  "about.contact.email": "电子邮箱",
  "about.contact.hours": "工作时间",
  "category.all": "全部",
  "article.read_more": "阅读全文",
  "article.related": "相关文章",
  "article.publish_date": "发布时间",
  "article.author": "作者",
  "article.back_to_list": "返回列表",
  "seo.home.title": "1996至成国际app官方下载 | 正版安全极速体验",
  "seo.home.description": "1996至成国际app是专业国际化服务平台，提供安全稳定的一站式服务体验。立即下载1996至成国际官方app，享受便捷操作、极速响应与全球化服务支持，注册即享专属福利。",
  "seo.home.keywords": "1996至成国际app,1996至成国际,至成国际app下载,1996至成国际官网,至成国际平台,国际app下载,1996至成官方版",
  "seo.about.title": "关于我们 - 1996至成国际",
  "seo.about.description": "1996至成国际品牌介绍，了解至成国际的品牌故事、行业信誉与联系方式。专业国际服务平台，1996年成立至今，服务覆盖全球。",
  "seo.about.keywords": "1996至成国际,至成国际品牌,至成国际信誉,至成国际联系方式,国际服务平台",
  "seo.categories.title": "服务分类 - 1996至成国际",
  "seo.categories.description": "1996至成国际提供多元化国际服务分类，涵盖跨境商务、国际投资、文化交流等领域。查看至成国际全部服务分类。",
  "seo.categories.keywords": "至成国际服务,1996至成国际分类,国际服务,跨境服务,投资服务",
  "seo.articles.title": "资讯中心 - 1996至成国际",
  "seo.articles.description": "1996至成国际资讯中心，提供最新的国际化服务动态、行业政策解读与专业分析文章。关注至成国际资讯，掌握前沿信息。",
  "seo.articles.keywords": "至成国际资讯,1996至成国际新闻,国际服务资讯,行业动态",
};